module.exports = __webpack_public_path__ + "img/soilmix.f793c566.jpg";